// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var WebhooksController = function ($scope, $location, $routeParams, Webhook, SuspendedHook) {
    $scope.filter = { entityId: $routeParams.entityId, type: $routeParams.type,  before: $routeParams.before, status: $location.search()["status"] };
    $scope.newUrl = null;

    $scope.loadWebhooks = function () {
        $scope.hooks = $scope.paginator(function (options, callback) {
            return Webhook.query(options, function () { callback(); });
        }, 
            { 
                entityIdFilter: $scope.filter.entityId, 
                hookEvent: $scope.filter.type, 
                before: $scope.filter.before, 
                status: $scope.filter.status 
            }, 100);
    }

    $scope.loadSuspendedUrls = function () {
        $scope.suspendedUrls = SuspendedHook.query();
    }

    $scope.addSuspendedUrl = function () {
        var newSuspendedHook = new SuspendedHook();
        newSuspendedHook.Url = $scope.newUrl;
        newSuspendedHook.$save({}, function () { $scope.loadSuspendedUrls(); });
    }

    $scope.removeSuspendedUrl = function (id) {
        SuspendedHook.remove({ id : id }, function () { $scope.loadSuspendedUrls(); });
    }

    $scope.loadWebhooks();
    $scope.loadSuspendedUrls();
};
WebhooksController.$inject = ['$scope', '$location', '$routeParams', 'Webhook', 'SuspendedHook'];
